"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingMetaModelEnum = void 0;
var BillingMetaModelEnum;
(function (BillingMetaModelEnum) {
  /** Начисление на покупку кредитов */
  BillingMetaModelEnum["credits_purchase_charge"] = "credits_purchase_charge";
  /** Начисление на подписку на план */
  BillingMetaModelEnum["plan_charge"] = "plan_charge";
  /** Ордер на все начисления за все митинги по контракту на услугу преподавателей */
  BillingMetaModelEnum["user_service_contract_order"] = "user_service_contract_order";
  /** Начисление за митинг по контракту на услугу преподавателей */
  BillingMetaModelEnum["user_service_contract_meeting_charge"] = "user_service_contract_meeting_charge";
  /** Ордер за отдельный митинг по безопасной сделке */
  BillingMetaModelEnum["meeting_safe_deal_order"] = "meeting_safe_deal_order";
  /** Начисление за отдельный митинг по безопасной сделке */
  BillingMetaModelEnum["meeting_safe_deal_charge"] = "meeting_safe_deal_charge";
  /** Начисление за отдельный митинг в кредитах */
  BillingMetaModelEnum["meeting_credits_charge"] = "meeting_credits_charge";
  /** Начисление за лицензию на коллекцию */
  BillingMetaModelEnum["collection_license_charge"] = "collection_license_charge";
  /** Начисление за апгрейд лицензии на коллекцию */
  BillingMetaModelEnum["collection_license_upgrade_charge"] = "collection_license_upgrade_charge";
})(BillingMetaModelEnum = exports.BillingMetaModelEnum || (exports.BillingMetaModelEnum = {}));
